import { useAppSelector, useTranslate } from '@common/hooks'
import Button from '@common/widgets/Button'
import { useEffect, useState } from 'react'

import classNames from './styles.module.scss'


export default function OwnerSharedLink(): JSX.Element {
  const appDirectoryLink = useAppSelector(store => store.common.data.config?.CB_WEB_URL) as string

  const { translate } = useTranslate()
  const [linkIsCopied, setLinkIsCopied] = useState(false)
  const [timeoutId, setTimeoutId] = useState<number | null>(null)

  useEffect(() => {
    return () => {
      if(timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [timeoutId])

  const handleCopyLink = async () => {
    const urlToCopy = appDirectoryLink + '/v2apps' + location.pathname
    try {
      await navigator.clipboard.writeText(urlToCopy)
      setLinkIsCopied(true)
      if(timeoutId) {
        clearTimeout(timeoutId)
      }
      const newTimeoutId = setTimeout(() => {
        setLinkIsCopied(false)
        setTimeoutId(null)
      }, 2000) as unknown as number

      setTimeoutId(newTimeoutId)
    } catch (_) {}
  }

  return (
    <div className={classNames.container}>
      <h2 className={classNames.title} data-test="shared-title">
        {translate('No reviews yet')}
      </h2>
      <p className={classNames.description} data-test="shared-description">
        {translate('Share your app for feedback')}
      </p>
      <Button
        className={classNames.button}
        data-test="copy-link-btn"
        onClick={handleCopyLink}
        variant="transparent-blue"
        width="md"
      >
        {!linkIsCopied ? translate('Copy link') : translate('Copied')}
      </Button>
    </div>
  )
}
